import * as React from "react";
const IconList = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.9865 5.99243H16.9865M10.9865 13.9924H16.9865M10.9865 9.99243H22.9865M10.9865 17.9924H22.9865M4.98645 9.99243C3.88188 9.99243 2.98645 9.097 2.98645 7.99243C2.98645 6.88786 3.88188 5.99243 4.98645 5.99243C6.09102 5.99243 6.98645 6.88786 6.98645 7.99243C6.98645 9.097 6.09102 9.99243 4.98645 9.99243ZM4.98645 17.9924C3.88188 17.9924 2.98645 17.097 2.98645 15.9924C2.98645 14.8879 3.88188 13.9924 4.98645 13.9924C6.09102 13.9924 6.98645 14.8879 6.98645 15.9924C6.98645 17.097 6.09102 17.9924 4.98645 17.9924Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconList;
